export default __webpack_public_path__ + "static/media/img_6.019c5140.jpg";